<template>
  <m-dialog ref="dlg" @save="save" :title="diklat && diklat.id ? 'Ubah Diklat' : 'Tambah Diklat'">
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="12" md="10" lg="8" xl="8">
        <v-form @submit.prevent data-vv-scope="form" lazy-validation>
          <v-card flat class="pa-5 mb-5">
            <v-row class="pa-5 pb-0">
              <v-col cols="12" class="pa-5">
                <m-alert
                  type="error"
                  show
                  :title="alert.diklat.form.judul"
                  :info="alert.diklat.form.deskripsi"
                  closable
                ></m-alert>
              </v-col>
            </v-row>
            <v-row wrap class="pa-5">
              <!-- <v-col cols="12">
                  <v-autocomplete
                    outlined
                    dense
                    autocomplete="false"
                    v-model="diklat.jenisdiklat"
                    :items="itemJenisDiklat"
                    no-data-text="Data Tidak Tersedia"
                    placeholder="Pilih Jenis Diklat"
                    label="Jenis Diklat"
                    name="Jenis Diklat"
                    item-value="id"
                    item-text="keterangan"
                    data-vv-name="jenis_diklat"
                    data-vv-as="Jenis Diklat"
                    return-object
                    v-validate="'required'"
                    :error-messages="errors.collect('form.jenis_diklat')"
                  ></v-autocomplete>
              </v-col>-->
              <v-col cols="12" class="my-0 py-0 px-5">
                <v-text-field
                  outlined
                  dense
                  autocomplete="false"
                  name="Nama"
                  placeholder="Isikan Nama Diklat"
                  label="Nama"
                  v-model="diklat.nama"
                  persistent-hint
                  data-vv-name="nama"
                  data-vv-as="Nama"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.nama')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="my-0 py-0 px-5">
                <v-text-field
                  outlined
                  dense
                  autocomplete="false"
                  name="Nama Singkat"
                  placeholder="Isikan Nama Singkat Diklat (Maksimal 10 Karakter)"
                  label="Nama Singkat"
                  v-model="diklat.singkat"
                  persistent-hint
                  data-vv-name="singkat"
                  data-vv-as="Nama"
                  v-validate="'required|max:10'"
                  :error-messages="errors.collect('form.singkat')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="my-0 py-0 px-5">
                <v-textarea
                  outlined
                  autocomplete="false"
                  name="Deskripsi"
                  placeholder="Isikan Deskripsi"
                  label="Deskripsi"
                  v-model="diklat.keterangan"
                  persistent-hint
                  data-vv-name="deskripsi"
                  data-vv-as="Deskripsi"
                  v-validate="''"
                  :error-messages="errors.collect('form.deskripsi')"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row class="px-5 py-0 my-0">
              <v-col cols="6" md="6" lg="6" class="px-5">
                <span>Mulai Pendaftaran Peserta</span>
                <datetime
                  type="datetime"
                  value-zone="Asia/Jakarta"
                  zone="Asia/Jakarta"
                  :format="{
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                      hour: 'numeric',
                      minute: '2-digit'
                    }"
                  :phrases="{ ok: 'Lanjut', cancel: 'Batal' }"
                  v-model="diklat.mulai_set_peserta"
                  class="timepicker"
                ></datetime>
              </v-col>
              <v-col cols="6" md="6" lg="6" class="px-5">
                <span>Selesai Pendaftaran Peserta</span>
                <datetime
                  type="datetime"
                  value-zone="Asia/Jakarta"
                  zone="Asia/Jakarta"
                  :format="{
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                      hour: 'numeric',
                      minute: '2-digit'
                    }"
                  :phrases="{ ok: 'Lanjut', cancel: 'Batal' }"
                  v-model="diklat.selesai_set_peserta"
                  class="timepicker"
                ></datetime>
              </v-col>
              <v-col cols="6" md="6" lg="6" class="px-5">
                <span>Mulai Pendaftaran Admin LMS, Instruktur, Narasumber dan Admin Pusat</span>
                <datetime
                  type="datetime"
                  value-zone="Asia/Jakarta"
                  zone="Asia/Jakarta"
                  :format="{
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                      hour: 'numeric',
                      minute: '2-digit'
                    }"
                  :phrases="{ ok: 'Lanjut', cancel: 'Batal' }"
                  v-model="diklat.mulai_set_admin_lms"
                  class="timepicker"
                ></datetime>
              </v-col>
              <v-col cols="6" md="6" lg="6" class="px-5">
                <span>Selesai Pendaftaran Admin LMS, Instruktur, Narasumber dan Admin Pusat</span>
                <datetime
                  type="datetime"
                  value-zone="Asia/Jakarta"
                  zone="Asia/Jakarta"
                  :format="{
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                      hour: 'numeric',
                      minute: '2-digit'
                    }"
                  :phrases="{ ok: 'Lanjut', cancel: 'Batal' }"
                  v-model="diklat.selesai_set_admin_lms"
                  class="timepicker"
                ></datetime>
              </v-col>
            </v-row>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
import { ALERT_INFO } from "@/const";
import moment from "moment";
export default {
  $_veeValidate: {
    validator: "new",
  },
  components: {},

  data() {
    return {
      diklat: {},
      defDiklat: {
        nama: "",
      },
      itemJenisDiklat: [
        {
          id: 1,
          singkat: "penyegaran-bidang-studi-angkatan-1",
          keterangan: "PENYEGARAN BIDANG STUDI ANGKATAN I",
        },
      ],
      itemMoodles: [],
      alert: ALERT_INFO,
      current_page: 1,
      page: null,
      cp: 1,
    };
  },
  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.diklat = obj ? { ...obj } : { ...this.defDiklat };
      if (obj) {
        this.diklat.mulai_set_peserta = moment(
          obj.mulai_set_peserta
        ).toISOString();
        this.diklat.selesai_set_peserta = moment(
          obj.selesai_set_peserta
        ).toISOString();
        this.diklat.mulai_set_admin_lms = moment(
          obj.mulai_set_admin_lms
        ).toISOString();
        this.diklat.selesai_set_admin_lms = moment(
          obj.selesai_set_admin_lms
        ).toISOString();
      }
      let x = this.$refs.dlg.open();
      this.$validator.reset();
      return x;
    },
    // eslint-disable-next-line
    save() {
      this.$validator
        .validateAll("form")
        .then((res) => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          return this.$store
            .dispatch("diklat/form", {
              instansi_id: this.instansi_id,
              obj: this.diklat,
            })
            .then((res) => {
              this.$refs.dlg.resolve();
              this.$forceUpdate();
              return res;
            })
            .catch((e) => e);
        })
        .catch((e) => e);
    },
  },
};
</script>
<style>
.timepicker {
  color: rgba(0, 0, 0, 0.87);
  padding: 9px 8px 9px;
  max-width: 100%;
  width: 100%;
  border: 1px solid grey;
  outline: 1px;
  background: transparent;
  border-radius: 4px;
}
.vdatetime-input {
  width: 500px;
}
</style>
